import React from 'react';
import PropTypes from 'prop-types';
/* eslint-disable max-len */
const SportHal = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      viewBox="0 0 60 60"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M47.0256 14.8491C46.8209 16.0486 46.7144 17.2973 46.7144 18.5781C46.7144 19.2306 46.7438 19.8751 46.7979 20.5067C47.9186 20.4434 49.0806 20.4119 50.2763 20.4086C49.6013 18.3189 48.4806 16.4278 47.0256 14.8491Z"
        fill="#009BB3"
      />
      <path
        d="M46.1106 13.9373C43.4417 11.4977 39.8921 10.0068 36.0002 10.0068C35.1324 10.0068 34.2832 10.0851 33.4556 10.227C37.3319 12.2959 40.4385 16.1139 42.3719 20.9283C43.4503 20.7831 44.5677 20.6658 45.727 20.5795C45.6718 19.9249 45.6429 19.2569 45.6429 18.5787C45.6429 16.9742 45.8042 15.4169 46.1106 13.9373Z"
        fill="#009BB3"
      />
      <path
        d="M41.6831 22.1045C40.0684 22.3477 38.5497 22.6552 37.121 23.0136C38.1479 25.2898 38.7329 27.8815 38.7329 30.6313C38.7329 34.2022 37.9358 37.4117 36.4326 39.9933C37.7023 39.9563 38.9611 39.7629 40.1815 39.4088C41.0204 39.1656 41.8357 38.8479 42.6195 38.4622C42.6998 38.4226 42.7786 38.3808 42.8584 38.3395L42.9822 37.7085C43.2366 36.111 43.4997 34.4589 43.4997 32.7741C43.4996 28.939 42.8524 25.3075 41.6831 22.1045Z"
        fill="#009BB3"
      />
      <path
        d="M50.5773 21.4797C49.3158 21.477 48.0949 21.5075 46.9185 21.5729C47.3888 25.0314 48.6499 27.9719 50.3373 29.4172C50.7675 28.0222 51 26.541 51 25.0068C51 23.7917 50.8511 22.6116 50.5773 21.4797Z"
        fill="#009BB3"
      />
      <path
        d="M24.8046 15.3639C24.7173 15.3639 24.631 15.3591 24.5437 15.3564C22.8353 17.3873 21.6578 19.8574 21.2068 22.537C21.2052 22.5483 21.203 22.559 21.2009 22.5703C21.1393 22.941 21.0943 23.316 21.0605 23.6937C21.0552 23.7552 21.0509 23.8179 21.0466 23.8796C21.0182 24.2529 21 24.6279 21 25.0066C21 26.5575 21.2368 28.0542 21.6755 29.4626C24.7414 26.8751 29.2386 24.1039 35.5792 22.3174C33.2837 18.1362 29.3131 15.3639 24.8046 15.3639Z"
        fill="#009BB3"
      />
      <path
        d="M31.7821 10.6143C31.7671 10.6185 31.7521 10.6223 31.7376 10.6271C31.376 10.7343 31.0214 10.8548 30.6726 10.9876C30.6212 11.0074 30.5703 11.0283 30.5189 11.0481C30.1717 11.1847 29.8294 11.3304 29.4967 11.4912C29.4876 11.4954 29.479 11.5002 29.4699 11.5051C29.1528 11.6588 28.8442 11.8265 28.541 12.0017C28.4783 12.0381 28.4151 12.0729 28.3525 12.1099C28.0562 12.2861 27.7669 12.4726 27.4846 12.6676C27.4284 12.7067 27.3732 12.7469 27.3175 12.7865C26.7122 13.2184 26.1406 13.6914 25.6086 14.2046C25.5909 14.2218 25.5733 14.2383 25.5551 14.2555C25.5358 14.2743 25.5192 14.2946 25.4999 14.3133C30.2018 14.586 34.2956 17.6079 36.6399 22.0329C38.0949 21.6606 39.642 21.3402 41.286 21.0847C39.2487 16.1401 35.9183 12.3451 31.7821 10.6143Z"
        fill="#009BB3"
      />
      <path
        d="M45.8411 21.6436C44.7794 21.7218 43.7524 21.8262 42.7609 21.9548C43.9271 25.2226 44.5716 28.8997 44.5716 32.7744C44.5716 34.4576 44.3268 36.0711 44.0781 37.6354C46.7197 35.9399 48.7956 33.4408 49.9596 30.4843C47.8801 28.9323 46.363 25.6163 45.8411 21.6436Z"
        fill="#009BB3"
      />
      <path
        d="M36.0743 23.29C29.5869 25.0852 25.0709 27.9335 22.064 30.5419C24.1752 35.8389 29.2188 39.6601 35.1807 39.9831C36.8002 37.4857 37.6621 34.2645 37.6621 30.6313C37.6621 27.9715 37.0851 25.4698 36.0743 23.29ZM26.693 33.9961C26.5939 34.0754 26.4755 34.1139 26.3582 34.1139C26.2012 34.1139 26.0459 34.0454 25.9398 33.913C25.8192 33.7635 25.6875 33.6061 25.5508 33.4437C25.096 32.9022 24.5806 32.2888 24.2721 31.6759C24.1387 31.4119 24.2453 31.0899 24.5094 30.9565C24.7735 30.8225 25.0954 30.9297 25.2289 31.1938C25.4812 31.6952 25.9542 32.2577 26.371 32.7543C26.513 32.923 26.6501 33.087 26.7755 33.2428C26.9609 33.4737 26.9234 33.8107 26.693 33.9961ZM32.7571 37.5012C32.6811 37.724 32.4732 37.8644 32.2499 37.8644C32.1925 37.8644 32.1347 37.8547 32.0774 37.8354C30.9845 37.4631 29.8938 36.9183 28.7437 36.1705C28.4962 36.0082 28.426 35.6765 28.5867 35.4285C28.7479 35.1805 29.0795 35.1103 29.3281 35.2715C30.4028 35.9706 31.4153 36.4769 32.4229 36.8208C32.7031 36.9162 32.8525 37.221 32.7571 37.5012Z"
        fill="#009BB3"
      />
      <path
        d="M17.2812 33.4688H11.0312V30.3438C11.0312 28.618 12.4305 27.2188 14.1562 27.2188C15.882 27.2188 17.2812 28.618 17.2812 30.3438V33.4688Z"
        fill="#009BB3"
      />
      <path d="M13.375 51.1249V35.0913L10.9938 50.1726L13.375 51.1249Z" fill="#009BB3" />
      <path d="M18.9062 50.2125L21.9687 51.4375L17.2812 35.0312H16.5101L18.9062 50.2125Z" fill="#009BB3" />
      <path d="M14.9375 35.0913V51.1249L17.3188 50.1726L14.9375 35.0913Z" fill="#009BB3" />
      <path d="M11.8023 35.0312H11.0313L6.34375 51.4375L9.40625 50.2125L11.8023 35.0312Z" fill="#009BB3" />
    </svg>
  );
};
/* eslint-enable max-len */

SportHal.defaultProps = {
  className: null,
};

SportHal.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default SportHal;
